import type { IconData } from '@stacksjs/iconify-core'

export const oneFingerTap: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24.482 12.907c.24 2.67.542 6.402.542 8.366c0 0 5.648 1.218 10.905 3.331c2.59 1.042 4.124 3.623 3.747 6.39a47.4 47.4 0 0 1-1.926 8.282c-.964 2.95-3.52 5.059-6.604 5.407c-1.583.18-3.466.317-5.514.317a48 48 0 0 1-6.045-.39c-2.7-.348-5.15-1.74-6.396-4.16c-1.037-2.014-2.172-4.982-2.83-9.082c-.292-1.826.43-3.647 1.78-4.91L15 23.785c0-5.341.13-8.86.26-11.029c.107-1.818 1.306-3.388 3.11-3.645c.476-.068.978-.112 1.478-.112c.448 0 .898.035 1.329.092c1.885.245 3.136 1.922 3.306 3.815Z\"/><path d=\"M31 14c0-6.075-4.925-11-11-11S9 7.925 9 14\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default oneFingerTap
